/* global femcare, axios */

femcare.search.searchBar = {
    activeType: '',
    antiforgeryToken: '',
    searchBar: null,
    searchResult: null,

    init() {
        if (document.querySelector('.search-bar .search-bar__field input')) {
            this.searchResult = document.querySelector('.search-results');
            this.searchBar = document.querySelector('.search-bar');
            this.initSearchForm();
            this.initLoadMoreButton();
        }
    },

    /**
     * Initialize the search form to handle fetching more search results.
     */
    initSearchForm() {
        const $form = document.querySelector('.search-bar form');

        $form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.search($form);
        });

        const params = new URLSearchParams(window.location.search);
        const searchQuery = params.get('q');

        // Case when query string is already in URL — auto-submit the search
        if (searchQuery) {
            const inputField = document.querySelector('.search-bar__field input[name="q"]');
            if (inputField) {
                inputField.value = searchQuery;
            }

            this.search($form);
        }
    },

    /**
     * Renders PowerReviews on cta panel for products.
     * This is needed only for load more and new search.
     */
    renderPowerReviews() {
        if (window.POWERREVIEWS) {
            let reviews = window.pr_render_options || [];
            window.POWERREVIEWS.display.render(reviews);
        }
    },

    /**
     * Initialize type navigation for tabs and dropdown (mobile and desktop).
     */
    initTypeNavigation() {
        const activeDesktopItem = document.querySelector('.search-navigation__item.search-navigation__item--active');
        const selectedMobileOption = document.querySelector('.search-navigation__selectmenu select option:checked');

        const searchNavigationButtons = document.querySelectorAll('.search-navigation__button');
        const searchNavigationDropdown = document.querySelector('.search-navigation__selectmenu select');

        const searchResultsElement = document.querySelector('.search-results');

        // Adds the modifier class to the search result container for the style differences between types
        const updateSearchResultsModifierClass = (type) => {
            if (searchResultsElement) {
                searchResultsElement.className = searchResultsElement.className
                    .split(' ')
                    .filter((cls) => !cls.startsWith('search-results--'))
                    .join(' ');

                searchResultsElement.classList.add(`search-results--${type}`);
            }
        };

        if (activeDesktopItem) {
            this.activeType = activeDesktopItem.dataset.type;
        } else if (selectedMobileOption) {
            this.activeType = selectedMobileOption.value;
        }
        if (this.activeType) {
            updateSearchResultsModifierClass(this.activeType);
        }

        if (searchNavigationButtons) {
            searchNavigationButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const $parentItem = button.closest('.search-navigation__item');
                    if ($parentItem) {
                        const type = $parentItem.dataset.type;

                        if (this.activeType !== type) {
                            this.activeType = type;

                            document.querySelectorAll('.search-navigation__item').forEach((item) => (
                                item.classList.remove('search-navigation__item--active')
                            ));
                            $parentItem.classList.add('search-navigation__item--active');

                            updateSearchResultsModifierClass(type);
                            this.filterResultsByType(type);
                            this.updateTotalHitsNumber();
                        }
                    }
                });
            });
        }

        if (searchNavigationDropdown) {
            searchNavigationDropdown.addEventListener('change', (e) => {
                const type = e.target.value;

                if (this.activeType !== type) {
                    this.activeType = type;
                    updateSearchResultsModifierClass(type);
                    this.filterResultsByType(type);
                    this.updateTotalHitsNumber();
                }
            });
        }
    },

    /**
     * Filter search results by type.
     * @param {string} type - The type to filter by.
     */
    filterResultsByType(type) {
        const results = document.querySelectorAll('.search-results .search-results__list > li');

        results.forEach((result) => {
            if (result.dataset.type === type) {
                result.classList.remove('hidden');
            } else {
                result.classList.add('hidden');
            }
        });

        const visibleResults = document.querySelectorAll(`.search-results .search-results__list > li[data-type="${type}"]:not(.hidden)`).length;

        this.hideLoadMoreButton(visibleResults);
        this.updateResultsCount(visibleResults);
    },

    /**
     * Update the search result number in the heading.
     * @param {number} count - The number of visible results.
     */
    updateResultsCount(count) {
        const resultNumberElement = document.querySelector('.search-result__number-current');
        if (resultNumberElement) {
            resultNumberElement.textContent = count;
        }
    },

    /**
     * Updates the value of the `.search-result__number-total` element
     * based on the total hits for the current selected type.
     */
    updateTotalHitsNumber() {
        const totalHitsElement = document.querySelector('.search-result__number-total');
        if (!totalHitsElement) {
            return;
        }

        let activeNavigationItem;

        if (window.innerWidth < 768) {
            activeNavigationItem = document.querySelector('.search-navigation__selectmenu select option:checked');
        } else {
            activeNavigationItem = document.querySelector('.search-navigation__item.search-navigation__item--active');
        }

        if (!activeNavigationItem || !activeNavigationItem.dataset.hitsNumber) {
            totalHitsElement.textContent = '0';

            return;
        }

        const totalHits = parseInt(activeNavigationItem.dataset.hitsNumber, 10) || 0;
        totalHitsElement.textContent = totalHits;
    },

    /**
     * Adds an event listener to the "Load More" button, fetching more results
     * via an AJAX call when clicked. It ensures only one "Load More" button exists at a time,
     * updates the results count, and sets focus to the title of the first newly loaded item
     * for better accessibility.
     */
    initLoadMoreButton() {
        document.addEventListener('click', (e) => {
            if (e.target.matches('.search-results__load-more')) {
                e.preventDefault();

                const searchForm = document.querySelector('.search-bar form');
                const offset = document.querySelectorAll(`.search-results .search-results__list > li[data-type="${this.activeType}"]:not(.hidden)`).length;
                const loadMoreButton = document.querySelector('.search-results__load-more');

                if (loadMoreButton) {
                    loadMoreButton.classList.add('btn-loading');
                    loadMoreButton.disabled = true;
                }

                const requestData = new URLSearchParams(new FormData(searchForm));
                requestData.append('facet_type', this.activeType);

                axios
                    .get(`${searchForm.action}?offset=${offset}`, {
                        params: Object.fromEntries(requestData),
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'text/html',
                        },
                    })
                    .then((response) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(response.data, 'text/html');

                        this.executeResponseScripts(doc);

                        const results = doc.querySelectorAll(
                            `.search-results .search-results__list > li[data-type="${this.activeType}"]`
                        );
                        const newLoadMoreButton = doc.querySelector('.search-results__load-more');

                        let firstNewItem = null;

                        if (results.length) {
                            const list = document.querySelector('.search-results__list');
                            results.forEach((result, index) => {
                                list.appendChild(result);
                                // Capture the first newly loaded item
                                if (index === 0) {
                                    firstNewItem = result;
                                }
                            });

                            // Ensure only one Load More button
                            if (loadMoreButton) {
                                loadMoreButton.remove();
                            }

                            if (newLoadMoreButton) {
                                const loadMoreContainer = document.querySelector('.search-results__load-more-container');
                                if (loadMoreContainer) {
                                    loadMoreContainer.appendChild(newLoadMoreButton);
                                }
                            }

                            // Set focus on the first newly loaded item
                            if (firstNewItem) {
                                const firstNewItemLink = firstNewItem.querySelector('a:not([tabindex="-1"])');
                                if (firstNewItemLink) {
                                    firstNewItemLink.focus();
                                }
                            }

                            // Update results count after loading more
                            const visibleResults = document.querySelectorAll(`.search-results .search-results__list > li[data-type="${this.activeType}"]:not(.hidden)`).length;

                            this.hideLoadMoreButton(visibleResults);
                            this.updateResultsCount(visibleResults);
                        } else {
                            // Remove Load More button if no more results
                            if (loadMoreButton) {
                                loadMoreButton.remove();
                            }
                        }

                        if (loadMoreButton) {
                            loadMoreButton.classList.remove('btn-loading');
                            loadMoreButton.disabled = false;
                        }

                        setTimeout(() => {
                            femcare.ctaPanel.quickBuy.init();
                            this.renderPowerReviews();
                        }, 0);
                    })
            }
        });
    },

    /**
     * Hide or show the Load More button based on the total hits and visible results.
     * @param {number} visibleResultsCount - The number of currently visible results for the active type.
     */
    hideLoadMoreButton(visibleResultsCount) {
        const loadMoreButton = document.querySelector('.search-results__load-more');

        // Get the total hits number for the current type
        const activeNavigationItem = document.querySelector(`.search-navigation__item[data-type="${this.activeType}"]`)
            || document.querySelector(`.search-navigation__selectmenu select option[value="${this.activeType}"]`);
        const totalHits = activeNavigationItem ? parseInt(activeNavigationItem.dataset.hitsNumber, 10) : 0;

        // Hide or show the Load More button
        if (loadMoreButton) {
            if (visibleResultsCount >= totalHits) {
                loadMoreButton.classList.add('hidden');
            } else {
                loadMoreButton.classList.remove('hidden');
            }
        }
    },

    /**
     * Perform the AJAX search.
     *
     * @param {HTMLFormElement} $form - Search form.
     */
    search($form) {
        const searchTerm = document.querySelector('.search-bar__field input[name=q]').value;
        window.history.replaceState(null, null, `?q=${searchTerm}`);
        const requestData = new URLSearchParams(new FormData($form));

        document.querySelector('.search-results').classList.add('hidden');
        femcare.loader.toggleLoader(this.searchBar, true);

        axios
            .get($form.action, {
                params: Object.fromEntries(requestData),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'text/html',
                },
            })
            .then((response) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(response.data, 'text/html');

                this.executeResponseScripts(doc);

                // Update search-results with HTML from response
                const results = document.querySelector('.search-results');
                const newResults = doc.querySelector('.search-results');
                if (results && newResults) {
                    results.replaceWith(newResults);
                    femcare.accessibility.init();
                }

                // Update search-results__no-results with HTML from response
                const noResults = document.querySelector('.search-results__no-results');
                const newNoResults = doc.querySelector('.search-results__no-results');
                if (noResults && newNoResults) {
                    noResults.replaceWith(newNoResults);
                }

                this.updateTotalHitsNumber();

                femcare.ctaPanel.quickBuy.init();
                this.initTypeNavigation();
                this.renderPowerReviews();

                const visibleResults = document.querySelectorAll(`.search-results .search-results__list > li[data-type="${this.activeType}"]:not(.hidden)`).length;
                const totalResults = document.querySelectorAll('.search-results .search-results__list > li').length;

                this.hideLoadMoreButton(visibleResults);
                this.updateResultsCount(visibleResults);
                this.filterResultsByType(this.activeType);

                this.addSearchAnalyticsData(searchTerm, totalResults);
                this.addAnalyticsForSearchItems(searchTerm, totalResults);
            })
            .finally(() => {
                document.querySelector('.search-results').classList.remove('hidden');
                femcare.loader.toggleLoader(this.searchBar, false);
            });
    },

    /**
     * TODO: Remove this logic when search page is moved to JSON oriented logic.
     * Executes all <script> tags found in the provided document.
     * Needed only for quick buy modal data.
     * @param {Document} doc - The parsed HTML document from the AJAX response.
     */
    executeResponseScripts(doc) {
        window.pr_render_options = [];
        const scripts = doc.querySelectorAll('script');
        scripts.forEach((oldScript) => {
            const newScript = document.createElement('script');
            newScript.textContent = oldScript.textContent;
            document.body.appendChild(newScript);
        });
    },

    /**
     * Adds GA4 events for general search.
     * @param {string} searchParam - The term that was searched for.
     * @param {number} itemsCount - The total number of search results returned for the query.
     */
    addSearchAnalyticsData(searchParam, itemsCount) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ga4_view_search_results',
            ga4_data: {
                search_term: searchParam,
                search_results_count: itemsCount,
            },
        });
    },

    /**
     * Adds GA4 events for search items.
     * @param {string} searchParam - The term that was searched for.
     * @param {number} itemsCount - The total number of search results returned for the query.
     */
    addAnalyticsForSearchItems(searchParam, itemsCount) {
        document.querySelectorAll('.search-results .cta-panel').forEach((item, index) => {
            item.addEventListener('click', () => {
                const searchItemUrl = item.querySelector('a').href;
                const searchItemText = item.querySelector('.cta-panel__title, .cta-panel__link a').textContent.trim();

                window.dataLayer.push({
                    event: 'ga4_select_search_result',
                    ga4_data: {
                        search_term: searchParam,
                        search_results_count: itemsCount,
                        link_url: searchItemUrl,
                        link_text: searchItemText,
                        index: index + 1,
                    },
                });
            });
        });
    },
};
